<div *ngIf="gameService.round === -1">
	<h1>Card Setup: {{ player.shortName }}’s Turn</h1>
	<div id="cardRef"></div>
</div>
<div *ngIf="gameService.round === 0">
	<h1>Board Setup: {{ player.shortName }}’s Turn</h1>
	<div *ngIf="gameService.turnStep === turnStepType.drawTile">
		<button *ngIf="!tiles.length" (click)="draw3Tiles()">Draw 3 Tiles</button>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.placeTile">
		<div *ngFor="let tile of tiles; let num = index" class="currentTile" [ngClass]="{'selected': tile === gameService.currentTile}"><span [ngStyle]="{'backgroundImage': tile.img, 'transform': 'rotate(' + tile.rotation + 'turn)'}" (click)="clickTile(num)"></span></div>
	</div>
</div>
<div *ngIf="gameService.round > 0">
	<h1>Round {{ gameService.round }}: {{ player.shortName }}’s Turn</h1>
	<div *ngIf="needToHeal"><div>
		<h3>{{ player.shortName }} is wounded and must return to camp.</h3>
		<p><button (click)="healing.emit()">Continue</button></p>
	</div></div>
	<div *ngIf="gameService.turnStep === turnStepType.drawTile">
		<p><button *ngIf="!tiles.length" (click)="drawTile.emit(tilesToDraw)">Draw {{ tilesToDraw > 1 ? tilesToDraw + ' Tiles' : 'a Tile' }}</button></p>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.placeTile">
		<div *ngFor="let tile of tiles; let num = index" class="currentTile" [ngClass]="{'selected': tile === gameService.currentTile}"><span [ngStyle]="{'backgroundImage': tile.img, 'transform': 'rotate(' + tile.rotation + 'turn)'}" (click)="clickTile(num)"></span></div>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.move">
		<h2>Move</h2>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.drawCard">
		<p *ngIf="!card"><button (click)="drawCard.emit(cardsToDraw)">Draw {{ cardsToDraw > 1 ? cardsToDraw + ' Cards' : 'a Card' }}</button></p>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.preCombat">
		<p *ngIf="gameService.midTurn && needToRoll && !dieValue"><button (click)="dieValue = dieRoll()">Roll a Die</button></p>
		<div *ngIf="gameService.midTurn && needToRoll && dieValue">
			<h1>{{ dieValue }}</h1>
			<h2 *ngIf="dieValue === 1 || dieValue === 2">Gain a Wound</h2>
			<h2 *ngIf="dieValue === 3 || dieValue === 4">Nothing Happens</h2>
			<h2 *ngIf="dieValue === 5 || dieValue === 6">Heal a Wound</h2>
			<p><button (click)="rolledDie.emit(dieValue); dieValue = 0">Continue</button></p>
		</div>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.postCombat">
		<div *ngIf="gameService.midTurn && tiles.length"><div *ngFor="let tile of tiles; let num = index" class="currentTile" [ngClass]="{'selected': tile === gameService.currentTile}"><span [ngStyle]="{'backgroundImage': tile.img, 'transform': 'rotate(' + tile.rotation + 'turn)'}" (click)="clickTile(num)"></span></div></div>
		<div *ngIf="card" class="currentCard">
			<hotm-card [card]="card"></hotm-card>
		</div>
	</div>
	<div *ngIf="gameService.turnStep === turnStepType.xpEnd && !needToHeal">
		<p *ngIf="player.XP.length"><button (click)="useXP.emit()">Use XP</button></p>
		<p *ngIf="!player.campLocation && player.location !== player.startLocation"><button (click)="moveCamp.emit()">Place Forward Camp</button></p>
		<p><button (click)="endTurn.emit()">End Turn</button></p>
	</div>
</div>
